import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const SortableRow = ({ id, children }: { id: string; children: (props: {
  dragRef: (node: HTMLElement | null) => void;
  dragStyle: React.CSSProperties;
  dragHandleProps: Record<string, unknown>;
}) => React.ReactNode }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.5 : 1 };
  return <>{children({ dragRef: setNodeRef, dragStyle: style, dragHandleProps: { ...attributes, ...listeners } })}</>;
};

export default SortableRow;
